import { useState, useRef, Fragment } from 'react';
import dynamic from 'next/dynamic';
import { useLocationState } from '../../context/location';
import { submitClientRequest } from '../../helpers/clientRequest';
import Input from '../Input';
import Textarea from '../Textarea';
import Button from '../Button';
import styles from '../../styles/modules/objects/ObjectsMapCatalogCommercialItem.module.scss';
import FormAgreement from '../FormAgreement';

const Modal = dynamic(() => import('../Modal'));

const ObjectsMapCatalogCommercialItem = () => {
  const locationState = useLocationState();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isSubmited, setIsSubmited] = useState(false);
  const [clientName, setClientName] = useState('');
  const [clientPhone, setClientPhone] = useState('');
  const [clientComment, setClientComment] = useState('');
  const [agreeWithPolicy, setAgreeWithPolicy] = useState(false);
  const clientNameId = useRef();
  const clientPhoneId = useRef();

  const handleFormSubmit = () => {
    clientNameId.current.setError(clientName.length <= 3);
    clientPhoneId.current.setError(clientPhone.length !== 11);

    if (clientName.length > 3 && clientPhone.length === 11 && agreeWithPolicy) {
      submitClientRequest({
        clientName,
        clientPhone: clientPhone,
        clientComment,
        pathName: window.location.pathname,
        whatComponent: 'ObjectsMapCatalogCommercialItem',
        location: locationState.name,
        platform: 'web'
      }).then((isSubmitted) => {
        if (isSubmitted) setIsSubmited(true);
      });
    }
  };

  return (
    <div className={styles.commercial}>
      <Modal
        title="Обратная связь"
        button={!isSubmited && 'Отправить'}
        buttonDisabled={!agreeWithPolicy}
        action={handleFormSubmit}
        visibility={isModalVisible}
        onClose={() => setIsModalVisible(false)}
      >
        {isSubmited ? (
          <Fragment>
            <div style={{ marginBottom: 18 }}>
              Спасибо за вашу заявку. Мы скоро с Вами свяжемся!
            </div>
            <img
              src="/images/thumbUp.png"
              alt=""
              style={{ padding: 50, width: '100%', boxSizing: 'border-box' }}
            />
          </Fragment>
        ) : (
          <Fragment>
            <div style={{ marginBottom: 18 }}>
              Оставьте свои контактные данные и мы с Вами свяжемся в самые кратчайшие сроки, поможем
              решить все имеющиеся у Вас вопросы!
            </div>
            <Input
              title="Имя"
              inputs={[
                {
                  placeholder: 'Василий Петрович',
                  value: clientName,
                  type: 'text'
                }
              ]}
              isWrappedStyle
              ref={clientNameId}
              onChange={(v) => setClientName(v[0])}
            />
            <Input
              title="Телефон"
              inputs={[
                {
                  placeholder: locationState.phone,
                  value: clientPhone,
                  mask: 'phone',
                  type: 'tel'
                }
              ]}
              isWrappedStyle
              ref={clientPhoneId}
              onChange={(v) => setClientPhone(v[0])}
            />
            <Textarea
              title="Коммментарий"
              placeholder="Например, «Хочу получить консультацию по коммерческой недвижимости»"
              autoHeight
              isWrappedStyle
              onChange={(v) => setClientComment(v)}
            />
            <FormAgreement onChange={setAgreeWithPolicy} />
          </Fragment>
        )}
      </Modal>
      <div className={styles.commercialContent}>
        <div className={styles.comemrcialTitle}>Не нашли подходящего варианта?</div>
        <div className={styles.comemrcialDescription}>
          Оставьте заявку на подбор объекта из закрытой базы нашим специалистам!
        </div>
      </div>
      <Button
        color="white"
        style={{ fontSize: 18, fontWeight: 600, padding: '12px 18px', flexShrink: 0 }}
        onClick={() => setIsModalVisible(true)}
      >
        Подобрать варианты
      </Button>
    </div>
  );
};

export default ObjectsMapCatalogCommercialItem;
